// src/services/trendProxyService.js
// MGMT-TREND-APPROVE-REJECT-KEY-01 Part B. Trend opportunity writes go through mgmt-backend's
// proxy (routes/trendProxyRoutes.js), which adds whook's write key server side, so no whook
// address and no key live in the panel for a write. Same idiom as the /api/places calls:
// T6_BASE + Firebase ID token in an Authorization: Bearer header.
//   POST  /api/trends/opportunities/:id/approve  { notes }
//   POST  /api/trends/opportunities/:id/reject   { reason, explanation, shouldTeachAgent }
//   PATCH /api/trends/opportunities/:id/status   { status, reason }
//   PATCH /api/trends/opportunities/bulk         { ids, updates }
// Reads (GET /v1/agent/discovery/opportunities) stay on whook directly.

import axios from 'axios';
import { T6_BASE, authHeader } from '../pages/enterprise/EnterpriseAgentAccessTab';

const TRENDS = `${T6_BASE}/api/trends/opportunities`;

async function send(method, url, body) {
    const res = await axios({ method, url, data: body, headers: await authHeader() });
    return res.data;
}

export const approveTrendOpportunity = (id, body = {}) =>
    send('post', `${TRENDS}/${encodeURIComponent(id)}/approve`, body);

export const rejectTrendOpportunity = (id, body) =>
    send('post', `${TRENDS}/${encodeURIComponent(id)}/reject`, body);

export const updateTrendOpportunityStatus = (id, body) =>
    send('patch', `${TRENDS}/${encodeURIComponent(id)}/status`, body);

export const bulkUpdateTrendOpportunities = (body) =>
    send('patch', `${TRENDS}/bulk`, body);

// The line the pages' alert shows. A 502/503 from the proxy carries whook's (or the proxy's)
// sentence in `message`; whook pass-throughs carry `error`; the staff guard carries a code.
export function trendActionError(err, fallback) {
    const data = err && err.response && err.response.data;
    const detail = (data && (data.message || data.error)) || (err && !err.response && err.message);
    return detail ? `${fallback}: ${detail}` : fallback;
}
